export default __webpack_public_path__ + "static/media/dropped-icon.4257cbd2.svg";